import { nanoid } from 'nanoid';

export type DbTypePrefix =
  'u' | 'f' | 'b' | 's' | 'si' | 'p' | 'ct' | 'cta' | 'cts' | 'c' | 'ca' | 'cs' | 'i' | 'ia'
  | 'mcc' | 'dcc' | 'uci' | 'ucsd' | 'cct' | 'cc' | 'a' | 'l'
  | 'st' | 'ruf' | 'rub' | 'rup' | 'ruct' | 'rfb' | 'rpct' | 'rua' | 'rui' | 'rai'
  | 'lct' | 'li'
  | 'jb' | 'pp' | 'ctp' | 'jp' | 'sjp' | 'spj' | 'sctj' | 'srpct' | 'sppj' | 'sctpj'
  | 'uc' | 'n';

const generateId = (prefix: DbTypePrefix) : string =>
  prefix + ':' + nanoid();

export default generateId;
